module.exports = __webpack_public_path__ + "99801b17bd803eb4b82cad75b82c81d5.svg";